module.exports = __webpack_public_path__ + "img/calendar-wait-black.48453e60.svg";